import request from '@/middleware/request'

const getConversationWrapUp = ({ customerId, startDate }) => {
  return request({
    url: `/session/wrap-up`,
    method: 'get',
    params: {
      customer_id: customerId,
      start_date: startDate
    }
  })
}

const saveConversationWrapUp = ({ sessionId, message }) => {
  return request({
    url: `/session/wrap-up`,
    method: 'put',
    data: {
      session_id: sessionId,
      message: message
    }
  })
}

const uploadAttachFile = (file, cancelTokenSource, onUploadProgress) => {
  const formData = new FormData()
  formData.append('file', file)

  return request({
    url: '/file/upload',
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress,
    cancelToken: cancelTokenSource.token,
    data: formData
  })
}

/*
const uploadAttachFileV0 = ({ fileBase64, fileName, fileType }) => {
  return request({
    url: `/chat/attach-file`,
    method: 'post',
    data: {
      file_base64: fileBase64,
      file_name: fileName,
      file_type: fileType
    }
  })
}
*/

const getFirstContactData = ({ customerId }) => {
  return request({
    url: `/chat/first-contact/customer/${customerId}`,
    method: 'get'
  })
}

const getLastContactData = ({ customerId, lastNDay }) => {
  return request({
    url: `/chat/last-contact/customer/${customerId}/day/${lastNDay}`,
    method: 'get'
  })
}

const sendChatMessage = data => {
  return request({
    url: '/chat/send-message',
    method: 'post',
    data: data
  })
}

/*
const sendChatMessage = data => {
  return request({
    url: `${process.env.VUE_APP_SOCIAL_PLUGIN}/api/agent/send/message`,
    method: 'post',
    data,
    timeout: (60000 * 3)
  })
}
*/

const getSessionsList = () => {
  return request({
    url: '/chat/sessions/list',
    method: 'get'
  })
}

const getChats = ({ agentSessionId, sessionId, conversationId }) => {
  return request({
    url: `/chat/agent-session/${agentSessionId}/session/${sessionId}/last-conversation/${conversationId}`,
    method: 'get'
  })
}

const getQueuesSummary = () => {
  return request({
    url: '/chat/queues/summary',
    method: 'get'
  })
}

// NOTE : ADDED FOR LIVE CALL SESSION : TOM
const getCustomerInfoBySessionId = SessionId => {
  return request({
    url: `livecall/customer/${SessionId}`
  })
}

const getVoiceQueuesSummary = () => {
  return request({
    url: '/livecall/queues/summary',
    method: 'get'
  })
}

const pickUpVoiceQueue = (queueId = null) => {
  let query = {}
  if (queueId) {
    query = {
      queue_id: queueId
    }
  }

  return request({
    url: '/livecall/queue/pick-up',
    method: 'get',
    params: query
  })
}

const pickUpQueue = (queueId = null) => {
  let query = {}
  if (queueId) {
    query = {
      queue_id: queueId
    }
  }

  return request({
    url: '/chat/queue/pick-up',
    method: 'get',
    params: query
  })
}

const closeAgentSession = data => {
  return request({
    url: '/agent/session/close',
    method: 'put',
    data: data
  })
}

const endSession = data => {
  return request({
    url: '/agent/session/social-plugin/end',
    method: 'put',
    data: data
  })
}

/*
const endSession = data => {
  return request({
    url: `${process.env.VUE_APP_SOCIAL_PLUGIN}/api/agent/session/close`,
    method: 'put',
    data: data
  })
}
*/

const updateLastConversationRead = data => {
  return request({
    url: '/chat/read',
    method: 'put',
    data: data
  })
}

const transferQueue = data => {
  return request({
    url: '/chat/transfer',
    method: 'post',
    data: data
  })
}

const getQueueName = () => {
  return request({
    url: '/queues/active',
    method: 'get'
  })
}

const getTypeQueues = () => {
  return request({
    url: '/livecall/queues/gettypequeues',
    method: 'get'
  })
}

const getQueueNameLiveCall = () => {
  return request({
    url: '/queues/active-livecall',
    method: 'get'
  })
}

const transferQueueLiveCall = data => {
  return request({
    url: '/livecall/transfer-livecall',
    method: 'post',
    data: data
  })
}

const closeAgentVoiceSession = data => {
  return request({
    url: '/agent/session/closevoice',
    method: 'put',
    data: data
  })
}

export default {
  getConversationWrapUp,
  saveConversationWrapUp,
  uploadAttachFile,
  getFirstContactData,
  getLastContactData,
  sendChatMessage,
  getSessionsList,
  getChats,
  getQueuesSummary,
  pickUpQueue,
  closeAgentSession,
  endSession,
  updateLastConversationRead,
  transferQueue,
  getQueueName,
  getTypeQueues,
  getVoiceQueuesSummary,
  pickUpVoiceQueue,
  getCustomerInfoBySessionId,
  closeAgentVoiceSession,
  getQueueNameLiveCall,
  transferQueueLiveCall
}
